import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthState } from "../hooks/useAuth";
import { useToasts } from "../hooks/useToasts";
import Spinner from "./Spinner";
import AccessDenied from "./AccessDenied";

let lastToastPath = null;

const PrivateRoute = ({ children, requiredRole, allowedRoles }) => {
  const state = useAuthState();
  const { addToast } = useToasts();
  const location = useLocation();

  if (state.loading) return <Spinner visible={true} />;
  if (!state.user) return <Navigate to="/login" replace />;

  // Check if user is deactivated and trying to access non-profile pages
  if (state.user.isActive === false) {
    // Only allow access to profile page for both self and admin deactivated users
    if (window.location.pathname !== "/profile") {
      // Show toast only once per path
      if (lastToastPath !== location.pathname) {
        lastToastPath = location.pathname;
        if (state.user.deactivatedBy === "self") {
          addToast("Account self-deactivated", "error-warning");
          setTimeout(() => {
            addToast("Reactivate to use your account", "success-info");
          }, 1500);
        } else if (state.user.deactivatedBy === "admin") {
          addToast("Account deactivated by admin", "error-warning");
          setTimeout(() => {
            addToast("Contact support for reactivation", "success-info");
          }, 1500);
        }
      }
      return <Navigate to="/profile" replace />;
    }
  }

  // Check role if required
  if (requiredRole) {
    if (requiredRole === "user" && state.user.role === "user") {
      // User has access
    } else if (requiredRole === "admin" && state.user.role === "admin") {
      // Admin has access
    } else if (
      requiredRole === "superadmin" &&
      state.user.role === "superadmin"
    ) {
      // SuperAdmin has access
    } else {
      return <AccessDenied />;
    }
  }

  // Check allowedRoles if provided
  if (allowedRoles && !allowedRoles.includes(state.user.role)) {
    return <AccessDenied />;
  }

  return children;
};

export default PrivateRoute;
